<template>
    <div class="kt-portlet">
        <div class="accordion accordion-toggle-arrow" id="ticketCategories">
            <div class="card" style="overflow:inherit">
                <div
                    class="card-header bg-transparent d-flex align-items-center"
                    id="headingOne"
                    data-toggle="collapse"
                    data-target="#ticketCatForm"
                    aria-controls="ticketCatForm"
                >
                    <div class="card-title">
                        {{ $t('label.details') }}
                    </div>
                    <span>{{ ticket.category }}</span>
                </div>
                <div id="ticketCatForm" class="collapse show" aria-labelledby="ticketCatForm" data-parent="#ticketCategories">
                    <div class="card-body">
                        <form @submit.prevent="updateTicketCategories($event)" class="d-flex align-items-center justify-content-between">
                            <kt-col lg="6" xs="9" md="6">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('label.ticket_categories') }}
                                    </kt-form-label>
                                    <select
                                        class="form-control"
                                        id="ticket_categories"
                                        v-model="selected_category"
                                        name="ticket_categories"
                                    >
                                        <option
                                            v-bind:key="index"
                                            v-for="(category, index) in ticketCategories"
                                            v-bind:value="category.label"
                                            :selected="ticket.category"
                                        >
                                            {{ category.label }}
                                        </option>
                                    </select>
                                </kt-form-group>
                            </kt-col>
                            <kt-form-action>
                                <kt-button
                                    id="ticket-form-btn"
                                    class="btn btn-success"
                                    type="submit"
                                    variant="success"
                                >
                                    {{ $t('btn.update') }}
                                </kt-button>
                            </kt-form-action>
                        </form>
                        <form @submit.prevent="updateCategories($event)" class="d-flex align-items-center justify-content-between">
                            <kt-col lg="6" xs="9" md="6">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('label.ticket_knowledge_categories') }}
                                    </kt-form-label>
                                    <select
                                        class="form-control kt-selectpicker"
                                        id="knowledge_categories"
                                        v-model="ticket.cat_ids"
                                        name="knowledge_categories"
                                        multiple
                                    >
                                        <option
                                            v-bind:key="index"
                                            v-for="(category, index) in categories"
                                            v-bind:value="category.id"
                                            :selected="isSelectedCat(category.id)"
                                        >
                                            {{ category.title }}
                                        </option>
                                    </select>
                                </kt-form-group>
                            </kt-col>
                            <kt-form-action>
                                <kt-button
                                    id="form-btn"
                                    class="btn btn-success"
                                    type="submit"
                                    variant="success"
                                >
                                    {{ $t('btn.update') }}
                                </kt-button>
                            </kt-form-action>
                        </form>
                        <form class="d-flex align-items-center justify-content-between">
                            <kt-col lg="6" xs="9" md="6">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('label.status') }}
                                    </kt-form-label>
                                    <select
                                        class="form-control kt-selectpicker"
                                        id="ticket_status"
                                        v-model="selected_ticket_status"
                                        name="ticket_status"
                                    >
                                        <option
                                            :key="index"
                                            v-for="(status, index) in statuses"
                                            :value="status.value"
                                            :disabled="status.value == null"
                                            :selected="status.value == null"
                                        >
                                            {{ status.title }}
                                        </option>
                                    </select>
                                </kt-form-group>
                            </kt-col>
                            <kt-form-action>
                                <kt-button
                                    type="button" @click="changeStatus"
                                    class="btn btn-success text-nowrap"
                                    variant="success"
                                    id="change_status_btn"
                                >
                                    {{ $t('ticket.btn.change_status') }}
                                </kt-button>
                            </kt-form-action>
                        </form>
                        <form class="d-flex align-items-center justify-content-between">
                            <kt-col lg="6" xs="9" md="6">
                                <kt-form-group>
                                    <div class="input-group mt-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-white text-dark" id="basic-addon1"
                                            >نام پشتیبان
                                              <span class="text-danger">*</span>
                                            </span>
                                        </div>
                                        <v-select
                                            v-model="selected_user"
                                            name="user"
                                            class="form-control vSelect"
                                            :options="optionsUser"
                                            :filterable="false"
                                            @search="onSearchUser"
                                            :getOptionLabel="(user) => user.id"
                                        >
                                            <template slot="no-options"> کاربر مورد نظر را انتخاب کنید </template>
                                            <template slot="option" slot-scope="options">
                                                <div class="d-flex align-items-center text-nowrap">
                                                    {{ options.full_name }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="options">
                                                <div class="selected d-flex align-items-center text-nowrap">
                                                    {{ options.full_name }}
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                </kt-form-group>
                            </kt-col>
                            <kt-form-action>
                                <kt-button
                                    type="button" @click="assignUser"
                                    class="btn btn-success text-nowrap"
                                    variant="success"
                                    id="assign_user_btn"
                                >
                                    {{ $t('ticket.btn.assign_user') }}
                                </kt-button>
                            </kt-form-action>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import {i18n} from "../../../plugins/i18n";
import {mapGetters} from "vuex";
import { KTApp } from '@/plugins/core/app'
import { ticketService } from '@/common/api.service'
import toastr from "toastr";
import {KTUtil} from "@/plugins/core/util";
import {statusStr, ticketStatus} from "@/constants/ticketStatus";
import _ from "lodash";

export default {
    props: {
        seenBy: {
            default() {
                return {}
            }
        },
        related_user: {
            default() {
                return {}
            }
        },
        ticket: {
            default() {
                return {}
            }
        },
        ticketCategories: {
            required: true
        }
    },
    data() {
        return {
            selected_category: this.ticket.category,
            selected_ticket_status: null,
            selected_user: this.ticket.responsible,
            optionsUser: [],
            statuses: [
                {
                    value: null,
                    title: i18n.t('selectpicker.nothing_selected')
                },
                {
                    value: ticketStatus.CLOSED,
                    title: statusStr.CLOSED
                },
                {
                    value: ticketStatus.SEEN_BY_ADMIN,
                    title: statusStr.SEEN_BY_ADMIN
                },
                {
                    value: ticketStatus.CREATED_BY_USER,
                    title: statusStr.CREATED_BY_USER
                },
            ],
        }
    },
    computed: {
        ...mapGetters('KnowledgeManagement', [
            'categories',
            'categoriesStatus'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    methods: {
        assignUser() {
            let btn = $('#assign_user_btn')

            if (this.selected_user == null) {
                this.toastr.error('فیلد نام پشتیبان الزامی می باشد!')
                return
            }

            KTApp.progress(btn)

            ticketService.assignAdmin(this.$route.params.hashid, {
                user_hashid: this.selected_user.id
            })
                .then((response) => {
                    this.toastr.success(response.data.message)
                })
                .catch((error) => {
                    this.toastr.error(error.response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        },
        changeStatus() {
            let form = $('#kt_chat_content')
            let btn = $('#change_status_btn')

            if (this.selected_ticket_status == null) {
                this.toastr.error('برای تغییر وضعیت چیزی انتخاب نکرده اید!')
                return
            }

            if(confirm('آیا از تغییر وضعیت تیکت مطمئنید؟')) {
                KTApp.progress(btn)
                ticketService.closeTicket(this.$route.params.hashid, {
                    status: this.selected_ticket_status
                })
                    .then(response => {
                        KTUtil.scrollTop()
                        this.selected_ticket_status = null
                        this.showMsg(form, 'success', response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
                    .catch((error) => {
                        KTUtil.scrollTop()
                        this.showMsg(form, 'danger', error.response.message)
                    })
            }
        },
        onSearchUser(full_name, loading) {
            if (full_name.length > 2) {
                this.searchUser(loading, full_name, this)
            }
        },
        searchUser: _.debounce((loading, full_name, vm) => {
            if (full_name.length > 2) {
                ticketService.searchUser({
                    full_name: full_name
                })
                    .then((response) => {
                        vm.optionsUser = response.data.data
                        loading(false);
                    })
            }
        }, 600),
        updateTicketCategories(e) {
            let btn = $('#ticket-form-btn')

            KTApp.progress(btn)

            let params = {
                category_id: this.ticketCategories.filter(item => item.label == this.selected_category)[0].id
            }

            ticketService.updateTicketCategory(this.$route.params.hashid, params)
                .then((response) => {
                    this.$store.dispatch('ticket/find', this.$route.params.hashid)
                    this.toastr.success(response.data.message)
                })
                .catch((error) => {
                    this.toastr.error(error.response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        },
        isSelectedCat(hashidd) {
            return Object.values(this.ticket.cat_ids).includes(hashidd)
        },
        updateCategories(e) {
            let btn = $('#form-btn')

            KTApp.progress(btn)

            let params = {
                cat_ids: this.ticket.cat_ids
            }

            ticketService.updateTicketCategories(this.$route.params.hashid, params)
                .then(response => {
                    this.toastr.success(response.data.message)
                })
                .catch((error) => {
                    this.toastr.error(error.response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        }
    },
    mounted() {
        this.$store.dispatch('KnowledgeManagement/fetchCategories').finally(() => {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        })
    }
}
</script>

<style scoped>
/*table td {*/
/*    border-top-style: hidden;*/
/*}*/
.tooltip_btn .tooltiptext {
    visibility: hidden;
    width: 150px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
}

.tooltip_btn:hover .tooltiptext {
    visibility: visible;
}

.cat-list{
    margin-right: 2px;
    padding: 6px;
    float: right;
    border-radius: 10px;
}
.close-but{
    border: 0;
    border-radius: 21px;
    padding: 2px 6px;
    margin: 0 5px;
}
</style>
